import axios from "axios";
import Modal from "react-modal";
import { AES } from "crypto-js";
import { saveAs } from "file-saver";
import { toast } from "react-toastify";
import React, { useState, lazy, Suspense } from "react";
import "react-toastify/dist/ReactToastify.css";
import { useReactToPrint } from "react-to-print";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import pImage from "../../../images/singleinvoice/print.svg";
import dImage from "../../../images/singleinvoice/delete.svg";
import editImage from "../../../images/singleinvoice/edit.svg";
import dowImage from "../../../images/singleinvoice/download_icon.svg";
import crssrImage from "../../../images/singleinvoice/cross-red.svg";
import { logout, reset } from "../../../features/auth/authSlice";
import { reset as invoiceReset } from "../../../features/invoice/invoiceSlice.js";
import { reset as headerReset } from "../../../features/headerText/headerTextSlice.js";
import { reset as appSettingsReset } from "../../../features/appSettings/appSettingsSlice.js";
const CommentContainer = lazy(() => import("../../../components/Comments/CommnetContatiner"));

const USER = 3;
const SUPER_ADMIN = 1;
const ADMIN = 2;
const TEAM_MANAGER = 7;

const ExpenseActions = ({ expenseData, setExpenseData, componentRef, token, refetch }) => {
  const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false);
  const [editModalIsOpen, setEditModalIsOpen] = useState(false);
  const [isCreatingPdf, setIsCreatingPdf] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [selectedExpenseId, setSelectedExpenseId] = useState("");
  const [formData, setFormData] = useState({
    exp_category: expenseData?.exp_category?._id || "",
    exp_description: expenseData?.exp_description || "",
    exp_sub_total: expenseData?.exp_sub_total || 0,
    exp_tax: expenseData?.exp_tax || 0,
    exp_amount: expenseData?.exp_amount || 0,
    exp_currency: expenseData?.exp_currency || "USD",
    exp_note: expenseData?.exp_note || "",
    exp_file_attch: [],
  });
  const [formErrors, setFormErrors] = useState({});

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const path = window.location.pathname + window.location.search + window.location.hash;

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `expense-${expenseData?.exp_id || "data"}`,
  });

  // const createPdf = async (e) => {
  //   e.preventDefault();
  //   setIsCreatingPdf(true);
  //   try {
  //     await axios.post(`/api/expense/pdf-create`, expenseData, {
  //       headers: { Authorization: `Bearer ${token}` },
  //     });
  //     const response = await axios.get(`/api/expense/download/created/pdf`, {
  //       responseType: "blob",
  //       headers: { Authorization: `Bearer ${token}` },
  //     });
  //     const filename = `${expenseData.exp_id}.pdf`;
  //     const pdfBlob = new Blob([response.data], { type: "application/pdf" });
  //     saveAs(pdfBlob, filename);
  //     toast.success(`Expense "${expenseData.exp_id}" downloaded successfully!`, {
  //       position: "bottom-right",
  //       autoClose: 1500,
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       progress: undefined,
  //       theme: "light",
  //     });
  //     global.config.activityLog(
  //       window.location.href,
  //       "Expense",
  //       `Expense "${expenseData.exp_id}" downloaded successfully!`
  //     );
  //   } catch (error) {
  //     console.error(error);
  //     global.config.slackMessage(error.toString());
  //     if (error.response?.data?.status === "deleted") {
  //       localStorage.removeItem("user");
  //       dispatch(logout());
  //       dispatch(reset());
  //       dispatch(invoiceReset());
  //       dispatch(headerReset());
  //       dispatch(appSettingsReset());
  //       toast.error("This user is deleted!", {
  //         position: "bottom-right",
  //         autoClose: 1500,
  //         hideProgressBar: false,
  //         closeOnClick: true,
  //         pauseOnHover: true,
  //         draggable: true,
  //         progress: undefined,
  //         theme: "light",
  //       });
  //       navigate("/");
  //       return;
  //     }
  //     toast.error("Something went wrong while creating the PDF.", {
  //       position: "bottom-right",
  //       autoClose: 2000,
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       progress: undefined,
  //     });
  //   } finally {
  //     setIsCreatingPdf(false);
  //   }
  // };

  const handleDeleteExpense = async (id) => {
    setSelectedExpenseId(id);
    setDeleteModalIsOpen(true);
  };

  const handleModalConfirm = async () => {
    try {
      setIsSubmitLoading(true);
      await axios.get(`/api/expense/delete/${selectedExpenseId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success(`Expense "${expenseData.exp_id}" removed successfully!`, {
        position: "bottom-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      global.config.activityLog(
        window.location.href,
        "Expense",
        `Expense "${expenseData.exp_id}" removed successfully!`
      );
      navigate("/user/expense/overview");
    } catch (error) {
      console.error(error);
      global.config.slackMessage(error.toString());
      if (error.response?.data?.status === "deleted") {
        localStorage.removeItem("user");
        dispatch(logout());
        dispatch(reset());
        dispatch(invoiceReset());
        dispatch(headerReset());
        dispatch(appSettingsReset());
        toast.error("This user is deleted!", {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/");
        return;
      }
      toast.error("Something went wrong while deleting the expense.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } finally {
      setIsSubmitLoading(false);
      setDeleteModalIsOpen(false);
    }
  };

  const handleModalCancel = () => {
    setDeleteModalIsOpen(false);
  };

  const handleEdit = () => {
    setFormData({
      exp_category: expenseData?.exp_category?._id || "",
      exp_description: expenseData?.exp_description || "",
      exp_sub_total: expenseData?.exp_sub_total || 0,
      exp_tax: expenseData?.exp_tax || 0,
      exp_amount: expenseData?.exp_amount || 0,
      exp_currency: expenseData?.exp_currency || "USD",
      exp_note: expenseData?.exp_note || "",
      exp_file_attch: [],
    });
    setFormErrors({});
    setEditModalIsOpen(true);
  };

  const handleFormChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "exp_file_attch") {
      setFormData((prev) => ({ ...prev, exp_file_attch: files }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.exp_category) errors.exp_category = "Category is required";
    if (!formData.exp_description) errors.exp_description = "Description is required";
    if (!formData.exp_sub_total || formData.exp_sub_total <= 0) {
      errors.exp_sub_total = "Subtotal must be greater than 0";
    }
    if (!formData.exp_currency) errors.exp_currency = "Currency is required";
    return errors;
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }
    try {
      setIsSubmitLoading(true);
      const formDataToSend = new FormData();
      formDataToSend.append("exp_category", formData.exp_category);
      formDataToSend.append("exp_description", formData.exp_description);
      formDataToSend.append("exp_sub_total", formData.exp_sub_total);
      formDataToSend.append("exp_tax", formData.exp_tax);
      formDataToSend.append("exp_amount", formData.exp_amount);
      formDataToSend.append("exp_currency", formData.exp_currency);
      formDataToSend.append("exp_note", formData.exp_note);
      if (formData.exp_file_attch.length > 0) {
        Array.from(formData.exp_file_attch).forEach((file) => {
          formDataToSend.append("exp_file_attch", file);
        });
      }
      const response = await axios.put(`/api/expense/${expenseData._id}`, formDataToSend, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      setExpenseData(response.data);
      toast.success(`Expense "${expenseData.exp_id}" updated successfully!`, {
        position: "bottom-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      global.config.activityLog(
        window.location.href,
        "Expense",
        `Expense "${expenseData.exp_id}" updated successfully!`
      );
      refetch();
      setEditModalIsOpen(false);
    } catch (error) {
      console.error(error);
      global.config.slackMessage(error.toString());
      if (error.response?.data?.status === "deleted") {
        localStorage.removeItem("user");
        dispatch(logout());
        dispatch(reset());
        dispatch(invoiceReset());
        dispatch(headerReset());
        dispatch(appSettingsReset());
        toast.error("This user is deleted!", {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/");
        return;
      }
      toast.error("Something went wrong while updating the expense.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } finally {
      setIsSubmitLoading(false);
    }
  };

  let encodedId = "";
  if (expenseData) {
    const encryptedId = AES.encrypt(expenseData._id, process.env.REACT_APP_ENCRYPTION_KEY || "encryptionKey").toString();
    encodedId = encodeURIComponent(encryptedId).replace(/\//g, "%2F");
  }

  return (
    <>
      <style>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
      `}</style>
      <div className="s1-contain s1-contain-with-comment">
        <div className="s1-contain-inner">
          <div className="bill-num-si">
            <a className="invoice-num-01">{expenseData?.exp_id || "N/A"}</a>
            {expenseData?.exp_status === true && (
              <div className="approve-top">Approved</div>
            )}
            {expenseData?.exp_status === false && (
              <div className="reject-top">Rejected</div>
            )}
            {expenseData?.exp_status == null && (
              <div className="pending-top pending">Pending</div>
            )}
          </div>
          <div className="btn-aary">
            {(expenseData?.exp_status == null || (user && (user.userType === SUPER_ADMIN || user.userType === ADMIN))) && (
              <Link to={`/user/expense/edit/${encodedId}`} className="editbtn-in-sle">
                <img src={editImage} alt="Edit Icon" /> Edit
              </Link>
            )}
            <a className="editbtn-in-slp" onClick={handlePrint}>
              <img src={pImage} alt="Print Icon" /> Print
            </a>
            {(expenseData?.exp_status == null || (user && (user.userType === SUPER_ADMIN || user.userType === ADMIN))) && (
              <a className="editbtn-in-sldow" onClick={() => handleDeleteExpense(expenseData._id)}>
                <img src={dImage} alt="Delete Icon" /> Delete
              </a>
            )}
          </div>
          <Modal
            className="delete-modal"
            isOpen={deleteModalIsOpen}
            onRequestClose={!isSubmitLoading ? handleModalCancel : undefined}
            contentLabel="Confirm Deletion"
            style={{
              content: {
                height: "auto",
                width: "30%",
                maxWidth: "400px",
                position: "relative",
                inset: "auto",
                top: "auto",
                left: "auto",
                right: "auto",
                bottom: "auto",
                margin: "auto",
                transform: "none",
              },
            }}
          >
            <div className="modal del-pop-modal">
              <div className="outter-modal-main delmodalicon">
                <a onClick={handleModalCancel} disabled={isSubmitLoading}>
                  <img src={crssrImage} alt="Close Icon" />
                </a>
              </div>
              <h2>Confirm Deletion?</h2>
              <div>
                <div className="modal-content-del">
                  <p>Are you sure you want to delete this expense?</p>
                </div>
                <div className="button-container btn-2-in-modal btn-2-in-modal-delete">
                  <button className="buttons-rejected" onClick={handleModalConfirm} disabled={isSubmitLoading}>
                    {isSubmitLoading ? (
                      <div
                        style={{
                          width: "60px",
                          height: "18px",
                          backgroundColor: "#ffffff",
                          borderRadius: "4px",
                          animation: "pulse 1.5s ease-in-out infinite",
                        }}
                      />
                    ) : (
                      "Delete"
                    )}
                  </button>
                  <button className="close-singlebtn" onClick={handleModalCancel} disabled={isSubmitLoading}>
                    Close
                  </button>
                </div>
              </div>
            </div>
          </Modal>
          <Modal
            isOpen={editModalIsOpen}
            onRequestClose={!isSubmitLoading ? () => setEditModalIsOpen(false) : undefined}
            contentLabel="Edit Expense"
            style={{
              content: {
                height: "60%",
                width: "40%",
                position: "fixed",
                top: "50%",
                left: "50%",
              },
            }}
          >
            <div className="modal">
              <div className="outter-modal-main delmodalicon">
                <a onClick={() => setEditModalIsOpen(false)} disabled={isSubmitLoading}>
                  <img src={crssrImage} alt="Close Icon" />
                </a>
              </div>
              <h2>Edit Expense</h2>
              <form onSubmit={handleEditSubmit}>
                <div className="modal-content">
                  <div>
                    <label>Category</label>
                    <input
                      type="text"
                      name="exp_category"
                      value={formData.exp_category}
                      onChange={handleFormChange}
                      className={formErrors.exp_category ? "input-validation-error" : ""}
                    />
                    {formErrors.exp_category && (
                      <span className="text-red-500 text-xs">{formErrors.exp_category}</span>
                    )}
                  </div>
                  <div>
                    <label>Description</label>
                    <textarea
                      name="exp_description"
                      value={formData.exp_description}
                      onChange={handleFormChange}
                      className={formErrors.exp_description ? "input-validation-error" : ""}
                    />
                    {formErrors.exp_description && (
                      <span className="text-red-500 text-xs">{formErrors.exp_description}</span>
                    )}
                  </div>
                  <div>
                    <label>Subtotal</label>
                    <input
                      type="number"
                      name="exp_sub_total"
                      value={formData.exp_sub_total}
                      onChange={handleFormChange}
                      className={formErrors.exp_sub_total ? "input-validation-error" : ""}
                    />
                    {formErrors.exp_sub_total && (
                      <span className="text-red-500 text-xs">{formErrors.exp_sub_total}</span>
                    )}
                  </div>
                  <div>
                    <label>Tax (%)</label>
                    <input
                      type="number"
                      name="exp_tax"
                      value={formData.exp_tax}
                      onChange={handleFormChange}
                    />
                  </div>
                  <div>
                    <label>Total Amount</label>
                    <input
                      type="number"
                      name="exp_amount"
                      value={formData.exp_amount}
                      onChange={handleFormChange}
                      className={formErrors.exp_amount ? "input-validation-error" : ""}
                    />
                    {formErrors.exp_amount && (
                      <span className="text-red-500 text-xs">{formErrors.exp_amount}</span>
                    )}
                  </div>
                  <div>
                    <label>Currency</label>
                    <select
                      name="exp_currency"
                      value={formData.exp_currency}
                      onChange={handleFormChange}
                      className={formErrors.exp_currency ? "input-validation-error" : ""}
                    >
                      <option value="USD">USD</option>
                      <option value="EUR">EUR</option>
                      <option value="GBP">GBP</option>
                      {/* Add more currencies as needed */}
                    </select>
                    {formErrors.exp_currency && (
                      <span className="text-red-500 text-xs">{formErrors.exp_currency}</span>
                    )}
                  </div>
                  <div>
                    <label>Note</label>
                    <textarea
                      name="exp_note"
                      value={formData.exp_note}
                      onChange={handleFormChange}
                    />
                  </div>
                  <div>
                    <label>Attachments</label>
                    <input
                      type="file"
                      name="exp_file_attch"
                      multiple
                      onChange={handleFormChange}
                    />
                  </div>
                </div>
                <div className="button-container btn-2-in-modal">
                  <button type="submit" className="buttons-approved" disabled={isSubmitLoading}>
                    {isSubmitLoading ? (
                      <div
                        style={{
                          width: "50px",
                          height: "18px",
                          backgroundColor: "#ffffff",
                          borderRadius: "4px",
                          animation: "pulse 1.5s ease-in-out infinite",
                        }}
                      />
                    ) : (
                      "Save"
                    )}
                  </button>
                  <button
                    type="button"
                    className="Reject-singlebtn"
                    onClick={() => setEditModalIsOpen(false)}
                    disabled={isSubmitLoading}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </Modal>
        </div>
        <div className="comment-container-outer">
          <Suspense fallback={
            <div className="comments-wrapper">
              <button
                className="comments-toggle-button"
                style={{
                  backgroundColor: "#CED5FD",
                  opacity: 0.6,
                  cursor: "not-allowed",
                  pointerEvents: "none",
                }}
              >
                <div
                  style={{
                    width: "16px",
                    height: "16px",
                    backgroundColor: "#405BFF",
                    borderRadius: "4px",
                    animation: "pulse 1.5s ease-in-out infinite",
                    marginTop: "5px",
                  }}
                />
                <div
                  style={{
                    width: "80px",
                    height: "17px",
                    backgroundColor: "#405BFF",
                    borderRadius: "4px",
                    animation: "pulse 1.5s ease-in-out infinite",
                  }}
                />
              </button>
            </div>
          }>
            <CommentContainer
              from={path}
              id={expenseData?._id}
              addUsers={[{
                _id: expenseData?.exp_client?.acc_manager?._id,
                name: (() => {
                  const user = expenseData?.exp_client?.acc_manager;
                  if (!user) return "";
                  const hasPersonalName = user.first_name?.trim() || user.last_name?.trim();
                  return hasPersonalName
                    ? `${user.first_name || ""} ${user.last_name || ""}`.trim()
                    : `${user.company_first_name || ""} ${user.company_last_name || ""}`.trim();
                })(),
              }]}
              permissions={["Admin", "Super admin", "Account manager"]}
            />
          </Suspense>
        </div>
      </div>
    </>
  );
};

export default ExpenseActions;